interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: (number | string)[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    if (i === 1 || i === totalPages || Math.abs(i - page) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "…") {
      pages.push("…");
    }
  }

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        className="flex h-9 items-center gap-1 rounded-md border border-background-200 px-3 text-sm text-foreground-600 transition-colors disabled:cursor-not-allowed disabled:opacity-40 enabled:hover:border-primary-300 enabled:hover:text-primary-700"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {pages.map((item, index) =>
        typeof item === "number" ? (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            aria-current={item === page}
            className={`h-9 w-9 rounded-md text-sm font-medium transition-colors ${
              item === page
                ? "bg-primary-500 text-background-50"
                : "border border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-700"
            }`}
          >
            {item}
          </button>
        ) : (
          <span key={`ellipsis-${index}`} className="px-1 text-foreground-400">
            …
          </span>
        ),
      )}

      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page >= totalPages}
        className="flex h-9 items-center gap-1 rounded-md border border-background-200 px-3 text-sm text-foreground-600 transition-colors disabled:cursor-not-allowed disabled:opacity-40 enabled:hover:border-primary-300 enabled:hover:text-primary-700"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}